// Load portfolio API client

import { fetchWithAuth } from "./http";
import type {
  LoadPortfolioSummary,
  LoadPortfolioDetail,
  LoadPortfolioCreateInput,
  LoadSource,
  LoadSourceCreateInput,
  LoadRun,
} from "../features/load-portfolio/domain/types";

const BASE = "/load-portfolios";

// --- Portfolio CRUD ---

export const listPortfolios = (token: string) =>
  fetchWithAuth<LoadPortfolioSummary[]>(BASE, token);

export const getPortfolio = (portfolioId: string, token: string) =>
  fetchWithAuth<LoadPortfolioDetail>(`${BASE}/${portfolioId}`, token);

export function createPortfolio(
  data: LoadPortfolioCreateInput,
  token: string
): Promise<LoadPortfolioDetail> {
  return fetchWithAuth<LoadPortfolioDetail>(BASE, token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updatePortfolio(
  portfolioId: string,
  data: Partial<LoadPortfolioCreateInput>,
  token: string
): Promise<LoadPortfolioDetail> {
  return fetchWithAuth<LoadPortfolioDetail>(`${BASE}/${portfolioId}`, token, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deletePortfolio(
  portfolioId: string,
  token: string
): Promise<void> {
  return fetchWithAuth<void>(`${BASE}/${portfolioId}`, token, {
    method: "DELETE",
  });
}

// --- Source CRUD ---

export function addSource(
  portfolioId: string,
  data: LoadSourceCreateInput,
  token: string
): Promise<LoadSource> {
  return fetchWithAuth<LoadSource>(`${BASE}/${portfolioId}/sources`, token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateSource(
  portfolioId: string,
  sourceId: string,
  data: Partial<LoadSourceCreateInput>,
  token: string
): Promise<LoadSource> {
  return fetchWithAuth<LoadSource>(`${BASE}/${portfolioId}/sources/${sourceId}`, token, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deleteSource(
  portfolioId: string,
  sourceId: string,
  token: string
): Promise<void> {
  return fetchWithAuth<void>(`${BASE}/${portfolioId}/sources/${sourceId}`, token, {
    method: "DELETE",
  });
}

// --- Run / Queue ---

export function queueRun(
  portfolioId: string,
  phase: string = "btm_only",
  token: string,
  scenarioYear?: number
): Promise<{ message: string; run_id: string }> {
  return fetchWithAuth<{ message: string; run_id: string }>(`${BASE}/${portfolioId}/queue`, token, {
    method: "POST",
    body: JSON.stringify({ phase, scenario_year: scenarioYear }),
  });
}

export const listRuns = (portfolioId: string, token: string) =>
  fetchWithAuth<LoadRun[]>(`${BASE}/${portfolioId}/runs`, token);

export const getLatestRun = (portfolioId: string, token: string) =>
  fetchWithAuth<LoadRun>(`${BASE}/${portfolioId}/runs/latest`, token);
